/*
 * Some pages have content that loads dynamically and isn't server-side rendered.
 * When linking to an anchor on those pages - eg. /my-page#my-id, the browser
 * will immediately jump to #my-id, but then after that, the dynamically loaded
 * content will change the length of the page and the user will no longer be
 * at the location of the anchor. This hook solves that in a bit of a hacky way,
 * by again jumping to the anchor after a delay (it's assumption dynamic content
 * will have loaded by the time this delay passes).
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { scrollToId } from 'lib/window/scrollUtils'

export default function useDelayedJumpToHash(delay: number = 1000) {
  const location = useLocation()

  useEffect(() => {
    const hash = location.hash.replace('#', '')
    if (!hash) return

    const timeout = window.setTimeout(() => {
      scrollToId(hash, 0)
    }, delay)

    return () => { window.clearTimeout(timeout) }

    // Should only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
